module.exports = __webpack_public_path__ + "media/images/flags/tw-448584b415da471a25dce979f07e8526.svg";